import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/site/Navbar';
import Hero from '@/components/site/Hero';
import FeaturedCollections from '@/components/site/FeaturedCollections';
import WhyChooseUs from '@/components/site/WhyChooseUs';
import About from '@/components/site/About';
import Testimonials from '@/components/site/Testimonials';
import Gallery from '@/components/site/Gallery';
import AppointmentForm from '@/components/site/AppointmentForm';
import Contact from '@/components/site/Contact';
import FAQSection from '@/components/site/FAQSection';
import Newsletter from '@/components/site/Newsletter';
import Footer from '@/components/site/Footer';
import FloatingActions from '@/components/site/FloatingActions';
import SEOContent from '@/components/site/SEOContent';
import useSEO from '@/hooks/useSEO';

export default function Home() {
  const { hash } = useLocation();
  useSEO({
    title: 'Indian Clothing USA · Trendy Closet Morrisville NC',
    description: 'Trendy Closet is a family-owned Indian clothing boutique in Morrisville, NC — designer lehengas, sarees, sharara suits, kurti sets, gowns, bridal & men\'s wear. Ships across the USA.',
  });
  // Scroll to the section referenced in the URL hash (e.g. /#collections) —
  // supports the Navbar's cross-page anchor links. We use a header-offset
  // scroll (not scrollIntoView) so the section isn't hidden behind the sticky
  // 80px header, and we wait two animation frames + a small delay so the
  // target section is definitely laid out before scrolling.
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    const HEADER_OFFSET = 80;
    let cancelled = false;
    const doScroll = () => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
    };
    // Wait 2 rAFs + 50ms to let async sections mount + images layout
    requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(doScroll, 50)));
    return () => { cancelled = true; };
  }, [hash]);
  return (
    <main data-testid="home-page" className="min-h-screen bg-ivory text-charcoal">
      <Navbar />
      <Hero />
      <Gallery />
      <FeaturedCollections />
      <SEOContent />
      <WhyChooseUs />
      <About />
      <Testimonials />
      <AppointmentForm />
      <Contact />
      <FAQSection />
      <Newsletter />
      <Footer />
      <FloatingActions />
    </main>
  );
}
